export default __webpack_public_path__ + "static/media/sankologo.52ab1a1c.png";